module.exports = __webpack_public_path__ + "ad3c4f050141da94f941949bdfeaca2b.png";